import {
    trackUnlockChoiceReservationAck,
    trackUnlockChoiceReservationBack,
    trackUnlockChoiceReservationClose,
    trackUnlockChoiceReservationCodeView,
    trackUnlockChoiceReservationConfirmedView,
    trackUnlockChoiceReservationResend
} from "../../auth/tracking/track_unlock_choice_reservation_events";
import {getReservationEntry} from "../constants/reservation_placement_config";
import {IReservationError} from "../types/IReservationError";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationEntry} from "../types/ReservationEntry";
import {ReservationStepName} from "../types/ReservationStepName";
import {
    IReservationTrackingContext,
    trackReservationClose,
    trackReservationCodeResend,
    trackReservationCodeSubmit,
    trackReservationCodeView,
    trackReservationConfirmedClose,
    trackReservationError,
    trackReservationGenerateLead,
    trackReservationLeadFormStart
} from "./track_reservation_events";

type TrackEvent = (request: IReservationRequest, context: IReservationTrackingContext) => void;
type TrackStepEvent = (request: IReservationRequest, step: ReservationStepName, context: IReservationTrackingContext) => void;

// The events of one reservation funnel - the flow and its hosts report every step through it, whichever entry the request came from
export interface IReservationTracker {
    leadFormStart: TrackEvent;
    // the first code of a run has been sent
    codeView: TrackEvent;
    codeSubmit: TrackEvent;
    // `codesSent` - codes sent before this resend
    resend: (request: IReservationRequest, codesSent: number, context: IReservationTrackingContext) => void;
    confirmed: (request: IReservationRequest, applicationUuid: string | null, context: IReservationTrackingContext) => void;
    error: (request: IReservationRequest, error: IReservationError, context: IReservationTrackingContext) => void;
    // each showing of a step by the host
    stepView: TrackStepEvent;
    // the close button of a step, the overlay or Esc
    close: TrackStepEvent;
    // ROZUMIEM of the confirmation
    confirmedClose: TrackEvent;
    // back from the code step to the choice it was started from
    back: TrackEvent;
}

const ignore = () => undefined;

// The reservation buttons: the lead form funnel with its GTM events, the views of the steps reported as the steps are reached
const LEAD_FORM_FUNNEL_TRACKER: IReservationTracker = {
    leadFormStart: trackReservationLeadFormStart,
    codeView: trackReservationCodeView,
    codeSubmit: trackReservationCodeSubmit,
    resend: trackReservationCodeResend,
    confirmed: trackReservationGenerateLead,
    error: trackReservationError,
    stepView: ignore,
    close: trackReservationClose,
    confirmedClose: trackReservationConfirmedClose,
    // a reservation button opens the steps without a way back
    back: ignore
};

// The reservation card of the unlock choice continues the funnel of its choice - step views and button clicks only
const UNLOCK_CHOICE_TRACKER: IReservationTracker = {
    leadFormStart: ignore,
    codeView: ignore,
    codeSubmit: ignore,
    resend: (request, _codesSent, context) => trackUnlockChoiceReservationResend(request, context),
    confirmed: ignore,
    error: ignore,
    stepView: (request, step, context) =>
        step === "code" ? trackUnlockChoiceReservationCodeView(request, context) : trackUnlockChoiceReservationConfirmedView(request, context),
    close: (request, step, context) => {
        // the confirmation has no close button - closed with the overlay or Esc it is not reported
        if (step === "code") {
            trackUnlockChoiceReservationClose(request, context);
        }
    },
    confirmedClose: trackUnlockChoiceReservationAck,
    back: trackUnlockChoiceReservationBack
};

const RESERVATION_TRACKERS: Record<ReservationEntry, IReservationTracker> = {
    cta: LEAD_FORM_FUNNEL_TRACKER,
    unlock_choice: UNLOCK_CHOICE_TRACKER
};

// A request handed over to another host (e.g. after an expired session) keeps the events of the funnel it was started in
export const getReservationTracker = (request: IReservationRequest): IReservationTracker => RESERVATION_TRACKERS[getReservationEntry(request)];
import {
    trackUnlockChoiceReservationAck,
    trackUnlockChoiceReservationBack,
    trackUnlockChoiceReservationClose,
    trackUnlockChoiceReservationCodeView,
    trackUnlockChoiceReservationConfirmedView,
    trackUnlockChoiceReservationResend
} from "../../auth/tracking/track_unlock_choice_reservation_events";
import {getReservationEntry} from "../constants/reservation_placement_config";
import {IReservationError} from "../types/IReservationError";
import {IReservationRequest} from "../types/IReservationRequest";
import {ReservationEntry} from "../types/ReservationEntry";
import {ReservationStepName} from "../types/ReservationStepName";
import {
    IReservationTrackingContext,
    trackReservationClose,
    trackReservationCodeResend,
    trackReservationCodeSubmit,
    trackReservationCodeView,
    trackReservationConfirmedClose,
    trackReservationError,
    trackReservationGenerateLead,
    trackReservationLeadFormStart
} from "./track_reservation_events";

type TrackEvent = (request: IReservationRequest, context: IReservationTrackingContext) => void;
type TrackStepEvent = (request: IReservationRequest, step: ReservationStepName, context: IReservationTrackingContext) => void;

// The events of one reservation funnel - the flow and its hosts report every step through it, whichever entry the request came from
export interface IReservationTracker {
    leadFormStart: TrackEvent;
    // the first code of a run has been sent
    codeView: TrackEvent;
    codeSubmit: TrackEvent;
    // `codesSent` - codes sent before this resend
    resend: (request: IReservationRequest, codesSent: number, context: IReservationTrackingContext) => void;
    confirmed: (request: IReservationRequest, applicationUuid: string | null, context: IReservationTrackingContext) => void;
    error: (request: IReservationRequest, error: IReservationError, context: IReservationTrackingContext) => void;
    // each showing of a step by the host
    stepView: TrackStepEvent;
    // the close button of a step, the overlay or Esc
    close: TrackStepEvent;
    // ROZUMIEM of the confirmation
    confirmedClose: TrackEvent;
    // back from the code step to the choice it was started from
    back: TrackEvent;
}

const ignore = () => undefined;

// The reservation buttons: the lead form funnel with its GTM events, the views of the steps reported as the steps are reached
const LEAD_FORM_FUNNEL_TRACKER: IReservationTracker = {
    leadFormStart: trackReservationLeadFormStart,
    codeView: trackReservationCodeView,
    codeSubmit: trackReservationCodeSubmit,
    resend: trackReservationCodeResend,
    confirmed: trackReservationGenerateLead,
    error: trackReservationError,
    stepView: ignore,
    close: trackReservationClose,
    confirmedClose: trackReservationConfirmedClose,
    // a reservation button opens the steps without a way back
    back: ignore
};

// The reservation card of the unlock choice continues the funnel of its choice - step views and button clicks only
const UNLOCK_CHOICE_TRACKER: IReservationTracker = {
    leadFormStart: ignore,
    codeView: ignore,
    codeSubmit: ignore,
    resend: (request, _codesSent, context) => trackUnlockChoiceReservationResend(request, context),
    confirmed: ignore,
    error: ignore,
    stepView: (request, step, context) =>
        step === "code" ? trackUnlockChoiceReservationCodeView(request, context) : trackUnlockChoiceReservationConfirmedView(request, context),
    close: (request, step, context) => {
        // the confirmation has no close button - closed with the overlay or Esc it is not reported
        if (step === "code") {
            trackUnlockChoiceReservationClose(request, context);
        }
    },
    confirmedClose: trackUnlockChoiceReservationAck,
    back: trackUnlockChoiceReservationBack
};

const RESERVATION_TRACKERS: Record<ReservationEntry, IReservationTracker> = {
    cta: LEAD_FORM_FUNNEL_TRACKER,
    unlock_choice: UNLOCK_CHOICE_TRACKER
};

// A request handed over to another host (e.g. after an expired session) keeps the events of the funnel it was started in
export const getReservationTracker = (request: IReservationRequest): IReservationTracker => RESERVATION_TRACKERS[getReservationEntry(request)];
